import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Pause = function Pause(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "6",
      y: "3",
      width: "8",
      height: "26",
      fill: !ignoreColor ? color : undefined
    }), /*#__PURE__*/_jsx("rect", {
      x: "18",
      y: "3",
      width: "8",
      height: "26",
      fill: !ignoreColor ? color : undefined
    })]
  });
};
export default Pause;